import { createFileRoute } from '@tanstack/react-router'
import { AdminAuthGate } from '../components/auth/admin-auth-gate'
import { AdminServices } from '../components/pages/AdminServices'

export const Route = createFileRoute('/admin_/services')({
  component: AdminServicesComponent,
  head: () => ({
    title: 'Services | AUTOGLOW Detailing Admin',
    meta: [
      { title: 'Services | AUTOGLOW Detailing Admin' },
      { name: 'robots', content: 'noindex,nofollow' },
    ],
  }),
})

function AdminServicesComponent() {
  return (
    <AdminAuthGate>
      <AdminServices />
    </AdminAuthGate>
  )
}
